import api from "../api";

export const leadsApi = {
  // =========================================================
  // GET ALL LEADS
  // =========================================================
  getAll: () =>
    api.get("/leads").then((res) => res.data),

  // =========================================================
  // GET ALL SENT EMAILS
  // =========================================================
  getSentEmails: () =>
    api
      .get("/leads/sent-emails")
      .then((res) => res.data),

  // =========================================================
  // GET ALL PENDING SCHEDULED EMAILS
  // Used by SentEmails.jsx
  // =========================================================
  getAllScheduledEmails: () =>
    api
      .get("/leads/scheduled-emails")
      .then((res) => res.data),

  // =========================================================
  // GET SINGLE LEAD
  // =========================================================
  getOne: (id) =>
    api
      .get(`/leads/${id}`)
      .then((res) => res.data),

  // Same single lead method used by LeadDetail
  getById: (id) =>
    api
      .get(`/leads/${id}`)
      .then((res) => res.data),

  // =========================================================
  // CREATE LEAD
  // =========================================================
  create: (data) =>
    api
      .post("/leads", data)
      .then((res) => res.data),

  // =========================================================
  // UPDATE LEAD
  // =========================================================
  update: (id, data) =>
    api
      .put(`/leads/${id}`, data)
      .then((res) => res.data),

  // =========================================================
  // DELETE LEAD
  // =========================================================
  remove: (id) =>
    api
      .delete(`/leads/${id}`)
      .then((res) => res.data),

  // =========================================================
  // SEND EMAIL NOW OR CREATE SCHEDULED EMAIL
  // =========================================================
  sendEmail: (id, formData) =>
    api
      .post(`/leads/${id}/send-email`, formData)
      .then((res) => res.data),

  // =========================================================
  // GET PENDING SCHEDULED EMAILS FOR ONE LEAD
  // =========================================================
  getScheduledEmails: (id) =>
    api
      .get(`/leads/${id}/scheduled-emails`)
      .then((res) => res.data),

  // =========================================================
  // EDIT PENDING SCHEDULED EMAIL
  // =========================================================
  updateScheduledEmail: (
    leadId,
    scheduledEmailId,
    formData,
  ) =>
    api
      .put(
        `/leads/${leadId}/scheduled-emails/${scheduledEmailId}`,
        formData,
      )
      .then((res) => res.data),

  // =========================================================
  // DELETE / CANCEL PENDING SCHEDULED EMAIL
  // =========================================================
  deleteScheduledEmail: (
    leadId,
    scheduledEmailId,
  ) =>
    api
      .delete(
        `/leads/${leadId}/scheduled-emails/${scheduledEmailId}`,
      )
      .then((res) => res.data),

  // =========================================================
  // SYNC CLIENT REPLIES FROM OUTLOOK / MICROSOFT GRAPH
  // =========================================================
  syncReplies: (id) =>
    api
      .post(`/leads/${id}/sync-replies`)
      .then((res) => res.data),

  // =========================================================
  // GET COMPLETE EMAIL THREAD FOR ONE LEAD
  // =========================================================
  getEmailThread: (id) =>
    api
      .get(`/leads/${id}/email-thread`)
      .then((res) => res.data),

  // =========================================================
  // ADD NOTE / MANUAL ACTIVITY
  // =========================================================
  addActivity: (id, data) =>
    api
      .post(`/leads/${id}/activities`, data)
      .then((res) => res.data),
};

export default leadsApi;